<div class="login-wrapper">
  <picture class="mountain">
     <div class="track">
        <img src="assets/img/login/mountain.png" alt="Mountain">
        <img src="assets/img/login/mountain.png" alt="Mountain">
     </div>
</picture>
<picture class="car-scene">
    <div class="car">
        <img src="assets/img/login/car-exausts.png" alt="Car" (click)="explode()">
            <!-- fumaça esquerda -->
        <div class="smoke smoke-left"></div>
        <div class="smoke smoke-left delay"></div>

        <!-- fumaça direita -->
        <div class="smoke smoke-right"></div>
        <div class="smoke smoke-right delay"></div>

        <div class="explosions left" [class.active]="isExploding">
		      <span></span><span></span><span></span>
	      </div>
        <div class="explosions right" [class.active]="isExploding">
		      <span></span><span></span><span></span>
	    </div>
    </div>
</picture>

  <div class="login-card">
    <div class="login-header">
      <div class="logo-red"></div>
    </div>

    <form class="form" [formGroup]="form">
      <!-- <label for="email">{{'user.login.email' | transloco}}*</label> -->
       <div class="title">
        <h1>BEM-VINDO AO <span class="highlight-red">FT PILOT</span></h1>
       </div>
       <div class="subtitle">
        <h2>Para prosseguir com o check-in, inicie a sessão ou crie uma nova conta!</h2>
       </div>

      <p-button 
          (click)="login()"
          severity="danger"
          [raised]="true"
          [loading]=""
          label="{{'user.login.signIn' | transloco}}">
      </p-button>

      <div class="button-wrapper" (click)="signUp()" >
        <div class="button-inner">
          <p-button id="btnBack" name="btnBack" label="{{'user.login.signUp' | transloco}}"  [raised]="true"
            styleClass="custom-button"></p-button>
        </div>
      </div>

      <div class="lang-box">
        <p-selectButton
          name="language"
          formControlName="language"
          [options]="languageOptions"
          optionLabel="name"
          optionDisabled="disabled"
          (click)="fixLanguage()"
        >
          <ng-template let-item pTemplate>
            <div [class]="item.class"></div>
          </ng-template>
        </p-selectButton>
        <!-- <span>Brasil - Português</span> -->
      </div>
    </form>
  </div>
  <p-toast key="toastMessages" />
</div>


